Vue.component('ack-hubspot-form-embed', {
	delimiters: ['${', '}$'],
	template: '#ack-hubspot-form-embed',
	props: {
		pageId: 'hubspot-form-embed',
		currentFormType: {
			type: String,
			required: true,
		},
		handleFormSubmit: {
			type: Function,
			required: false,
		},
	},
	created() {},
	mounted() {
		this.currentForm = this.hubspotFormTypes[this.currentFormType];
		this.setFormFunction();
		if (window.hbspt) {
			this.createForm();
			this.setPageIsLoading(false);
		} else {
			this.loadScript().then(() => {
				this.createForm();
				this.setPageIsLoading(false);
			});
		}
	},
	computed: {},
	data() {
		return {
			currentForm: '',
			hubspotFormTypes: {
				contactaDigitalDentistryExpert: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: 'deb42739-4d04-4bd5-8e29-0eedd976683e',
				},
				partnerWithUs: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: 'ef9fc9bc-2c3e-4789-b8aa-67678faf47fa',
				},
				becomeOurDistributor: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: '889529b2-1ea9-4f20-a1ce-b69ddfb4fe86',
				},
				techSupportTicket: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: '927353b8-eaee-4ec5-84c9-0f5ee65c9420',
				},
				downloadAlphaAiForFree: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: '17949e2e-2fc2-44a5-a552-5f1ca922b2e1',
					onFormSubmit: null,
				},
				solLeaseProgram: {
					target: '#hs-form',
					region: 'na1',
					portalId: '2471334',
					formId: '0ea4c9f2-fac6-48fc-ac36-449abe133ff9',
				},
				solAndSolPlusForm: {
					portalId: '2471334',
					formId: 'deb42739-4d04-4bd5-8e29-0eedd976683e',
					region: 'na1',
					target: '#hs-form',
				},
			},

			hubspotScriptSrc: '//js.hsforms.net/forms/v2.js',
		};
	},

	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		loadScript() {
			return new Promise((resolve) => {
				const script = document.createElement('script');
				script.src = this.hubspotScriptSrc;
				script.onload = resolve;
				document.body.appendChild(script);
			});
		},
		createForm() {
			window.hbspt.forms.create(this.currentForm);
		},
		setFormFunction() {
			if (this.handleFormSubmit) {
				this.currentForm.onFormSubmit = this.handleFormSubmit;
			}
		},
	},
});
